import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

const decode = (v: any) => {
  try {
    return JSON.parse(v);
  } catch (error) {
    return undefined;
  }
};
@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}
  public async set(key: string, value: any) {
    await Preferences.set({
      key,
      value: JSON.stringify(value),
    });
  }
  public async get(key: string) {
    const { value } = await Preferences.get({ key });
    return decode(value);
  }
  public async remove(key: string) {
    await Preferences.remove({ key });
  }
  public async keys() {
    const { keys } = await Preferences.keys();
    return keys;
  }
  public async clear() {
    await Preferences.clear();
  }
}
